import React, { useState } from "react";
import { WebsiteBuilderToolbarMenuView } from "../../../WebsiteBuilderToolbarMenuView";
import { useTranslation } from "react-i18next";
import { ButtonNew as Button } from "components/buttonNew";
import Input from "components/form/input";
import Checkbox from "components/form/checkbox/Checkbox";
import "./addLinkView.scss";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { websiteBuilderAddNavigationMenuItem } from "redux/actions/websiteBuilder/editor/websiteBuilderEditor";

interface IAddLinkViewProps {
  disabled: boolean;
  goBackToParentView: () => void;
}

interface IAddLinkViewState {
  label: string;
  labelValid: boolean;
  labelDirty: boolean;
  externalUrl: string;
  externalUrlValid: boolean;
  externalUrlDirty: boolean;
  openInNewTab: boolean;
}

export function AddLinkView(props: IAddLinkViewProps) {
  const { disabled, goBackToParentView } = props;

  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const websiteVersion = useAppSelector(store => store.websiteBuilderStore.editor.websiteVersion);

  const [state, setState] = useState<IAddLinkViewState>({
    label: "",
    labelValid: false,
    labelDirty: false,
    externalUrl: "",
    externalUrlValid: false,
    externalUrlDirty: false,
    openInNewTab: true,
  });

  const addLinkEnabled = !disabled && state.labelValid && state.externalUrlValid;

  function addLink() {
    void dispatch(websiteBuilderAddNavigationMenuItem(
      {
        website_version_id: websiteVersion.id,
        page_id: null,
        type: "external",
        label: state.label,
        external_url: state.externalUrl,
        open_in_new_tab: state.openInNewTab,
        parent_id: null,
      },
      t,
      goBackToParentView,
    ));
  }

  function renderAddLinkSettingsSection() {
    return (
      <div className="website-builder-add-link-settings-section">
        <Input
          label={t("Label")}
          value={state.label}
          onChange={e => setState(prev => ({ ...prev, label: e.target.value, labelValid: e.target.value?.length > 0, labelDirty: true }))}
          error={!state.labelValid && state.labelDirty}
        />
        <Input
          label={t("Url")}
          value={state.externalUrl}
          onChange={e => setState(prev => ({ ...prev, externalUrl: e.target.value, externalUrlValid: e.target.value?.length > 0, externalUrlDirty: true }))}
          error={!state.externalUrlValid && state.externalUrlDirty}
        />
        <Checkbox
          size="medium"
          label={t("Open link in new tab")}
          checked={state.openInNewTab}
          onChange={e => setState(prev => ({ ...prev, openInNewTab: e.target.checked }))}
        />
      </div>
    );
  }

  function renderAddLinkSaveSection() {
    return (
      <div className="website-builder-add-link-save-section">
        <Button
          type="secondary"
          className="add-link-save-action"
          onClick={goBackToParentView}
        >
          {t("Cancel")}
        </Button>
        <Button
          type="primary"
          className="add-link-save-action"
          onClick={addLink}
          disabled={!addLinkEnabled}
        >
          {t("Save")}
        </Button>
      </div>
    );
  }

  return (
    <WebsiteBuilderToolbarMenuView
      title={t("Add link")}
      goBackToParentView={goBackToParentView}
      footer={renderAddLinkSaveSection()}
      sections={[
        {
          content: renderAddLinkSettingsSection(),
        },
      ]}
    />
  );
}